// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__23kcK","actions":"GroupTable_actions__3oayc","deleteModalFooter":"GroupTable_deleteModalFooter__3QLsq"};